const ZDANIA30 = [
  {
    name: "[5 klasa] Angielski - past simple - 30",
    lang: 'en',
    zdania: [
      {
        pl: "być",
        de: "to be, was/were, been",
      },
      {
        pl: "bić",
        de: "to beat, beat, beaten",
      },
      {
        pl: "stawać się",
        de: "to become, became, become",
      },
      {
        pl: "zaczynać",
        de: "to begin, began, begun",
      },
      {
        pl: "gryźć",
        de: "to bite, bit, bitten",
      },
      {
        pl: "dmuchać",
        de: "to blow, blew, blown",
      },
      {
        pl: "łamać",
        de: "to break, broke, broken",
      },
      {
        pl: "przynosić",
        de: "to bring, brought, brought",
      },
      {
        pl: "budować",
        de: "to build, built, built",
      },
      {
        pl: "kupować",
        de: "to buy, bought, bought",
      },
      {
        pl: "łapać",
        de: "to catch, caught, caught",
      },
      {
        pl: "wybierać",
        de: "to choose, chose, chosen",
      },
      {
        pl: "przychodzić",
        de: "to come, came, come",
      },
      {
        pl: "kosztować",
        de: "to cost, cost, cost",
      },
      {
        pl: "ciąć",
        de: "to cut, cut, cut",
      },
      {
        pl: "rozprawiać",
        de: "to deal, dealt, dealt",
      },
      {
        pl: "kopać",
        de: "to dig, dug, dug",
      },
      {
        pl: "robić",
        de: "to do, did, done",
      },
      {
        pl: "rysować",
        de: "to draw, drew, drawn",
      },
      {
        pl: "pić",
        de: "to drink, drank, drunk",
      },
      {
        pl: "prowadzić",
        de: "to drive, drove, driven",
      },
      {
        pl: "jeść",
        de: "to eat, ate, eaten",
      },
      {
        pl: "upadać",
        de: "to fall, fell, fallen",
      },
      {
        pl: "karmić",
        de: "to feed, fed, fed",
      },
      {
        pl: "czuć",
        de: "to feel, felt, felt",
      },
      {
        pl: "walczyć",
        de: "to fight, fought, fought",
      },
      {
        pl: "znajdować",
        de: "to find, found, found",
      },
      {
        pl: "latać",
        de: "to fly, flew, flown",
      },
      {
        pl: "zabraniać",
        de: "to forbid, forbade, forbidden",
      },
      {
        pl: "zapominać",
        de: "to forget, forgot, forgotten",
      },
      { pl: "dawać", de: "to give, gave, given" },
      { pl: "iść", de: "to go, went, gone" },
      { pl: "rosnąć", de: "to grow, grew, grown" },
      { pl: "wisieć", de: "to hang, hung, hung" },
      { pl: "mieć", de: "to have, had, had" },
      { pl: "słyszeć", de: "to hear, heard, heard" },
      { pl: "ukrywać", de: "to hide, hid, hidden" },
      { pl: "ranić", de: "to hurt, hurt, hurt" },
      { pl: "trzymać", de: "to keep, kept, kept" },
      { pl: "znać", de: "to know, knew, known" },
      { pl: "prowadzić", de: "to lead, led, led" },
    ],
  },
];
const ZDANIA31 = [
  {
    name: "[5 klasa] Niemiecki Mod. 5 Kap 1 - 31",
    lang: 'de',
    zdania: [
      {
        pl: "Monika jest wegetarianką",
        de: "Monika ist Vegetarierin",
      },
      {
        pl: "Jestem wegetarianinem",
        de: "Ich bin Vegetarier",
      },
      {
        pl: "Monika jest od od roku weganką",
        de: "Monika ist seit einem Jahr Veganerin",
      },
      {
        pl: "Jestem od roku weganinem",
        de: "Ich bin seit einem Jahr Veganer",
      },
      {
        pl: "To znaczy, że nie je mięsa, ryb, jaj produktów zwierzęcych",
        de: "d.h. sie isst kein Fleisch, Fisch, Eier, Tierprodukte",
      },
      {
        pl: "Ona je za to to dużo warzyw, owoców, makaronu, musli i produktów sojowych",
        de: "Sie isst aber viel Gemüse, Obst, Nudeln, Müsli und Sojaprodukte",
      },
      {
        pl: "Monika nie je mięsa",
        de: "Monika isst kein Fleisch",
      },
      {
        pl: "Ona twierdzi, że produkty sojowe są pyszne i dobrze smakują",
        de: "Sie meint Sojaprodukte sind lecker und schmecken gut",
      },
      {
        pl: "Te produkty ona kupuje w skelpach ekologicznych",
        de: "Diese Produkte kauft sie in Bio-Läden",
      },
      {
        pl: "Na przykład sojowe jogurty",
        de: "Zum Beispiel Sojajoghurt",
      },
      {
        pl: "Kiełbasa",
        de: "die Wurst",
      },
      {
        pl: "Szynka",
        de: "der Schinken",
      },
      {
        pl: "Ser",
        de: "der Käse",
      },
      {
        pl: "Makaron",
        de: "die Nudeln",
      },
      {
        pl: "Musli",
        de: "das Müsli",
      },
      {
        pl: "Ziemniaki",
        de: "die Kartoffeln",
      },
      {
        pl: "produkty ekologiczne",
        de: "die Bio-Produkte",
      },
      {
        pl: "jajka",
        de: "die Eier",
      },
      {
        pl: "mleko",
        de: "die Milch",
      },
      {
        pl: "ryz",
        de: "der Reis",
      },
      {
        pl: "warzywa",
        de: "das Gemüse",
      },
      {
        pl: "ryba",
        de: "der Fisch",
      },
      {
        pl: "produkty sojowe",
        de: "die Sojaprodukte",
      },
      {
        pl: "Weganim moze jesc tylko warzywa i owoce",
        de: "Der Veganer darf nur Gemüse und Obst essen",
      },
      {
        pl: "Dlaczego tata nie moze wiecej palic?",
        de: "Warum darf Vati nicht mehr rauchen?",
      },
      {
        pl: "On nie moze wiecej palic, bo ma palenie jest grozne",
        de: "Er darf nicht mehr rauchen, denn Rauchen ist gefährlich",
      },
      {
        pl: "Dlaczego on nie moze pic wiecej kawy?",
        de: "Warum darf er nicht mehr Kaffee trinken?",
      },
      {
        pl: "On nie moze pic wiecej kawy, bo kawa szkodzi zoladkowi",
        de: "Er darf nicht mehr Kaffee trinken, denn Kaffee schadet dem Magen",
      },
      {
        pl: "Dlaczego on nie moze wiecej jesc?",
        de: "Warum darf er nicht mehr essen?",
      },
      {
        pl: "On nie moze wiecej jesc, bo on ma 15kg nadwagi",
        de: "Er darf nicht mehr essen, denn er hat 15kg Übergewicht",
      },
      {
        pl: "Dlaczego tata ma bol zeba?",
        de: "Warum hat Vati Zahnschmerzen?",
      },
      {
        pl: "On ma bol zeba, bo on je za duzo slodyczy",
        de: "Er hat Zahnschmerzen, denn er isst zu viel Süßigkeiten",
      },
      {
        pl: "Dlaczego tata jest taki nerwowy?",
        de: "Warum ist Vati so nervös?",
      },
      {
        pl: "On jest taki nerwowy, bo on ma duzo stresu",
        de: "Er ist so nervös, denn er hat viel Stress",
      },
      {
        pl: "Miec bol glowy",
        de: "Kopfschmerzen haben",
      },
      {
        pl: "byc ciagle zmeczonym",
        de: "immer müde sein",
      },
      {
        pl: "za malo spac",
        de: "zu wenig schlafen",
      },
      {
        pl: "bol brzucha",
        de: "Bauchschmerzen haben",
      },
      {
        pl: "za duzo jedzenia",
        de: "zu viel essen",
      },

      {
        pl: "jesc za tłusto",
        de: "zu fett essen",
      },
      {
        pl: "miec nadwage",
        de: "Übergewicht haben",
      },
      {
        pl: "czesto byc chory",
        de: "oft krank sein",
      },
      {
        pl: "niezdrowe zycie",
        de: "ungesundes Leben",
      },
      {
        pl: "brak sportu",
        de: "kein Sport treiben",
      },
      {
        pl: "chleb",
        de: "das Brot",
      },
      {
        pl: "ciemny chleb",
        de: "das Schwarzbrot",
      },
      {
        pl: "ciasto",
        de: "der Kuchen",
      },
      {
        pl: "lody",
        de: "das Eis",
      },
      {
        pl: "łyzeczka miodu",
        de: "der Teelöffel Honig",
      },
      {
        pl: "lyzczeka marmolady",
        de: "der Teelöffel Marmelade",
      },
      {
        pl: "czekolada",
        de: "die Schokolade",
      },
      {
        pl: "parówki",
        de: "die Würstchen",
      },
      {
        pl: "pieczeń wołowa",
        de: "das Ridernbraten",
      },
      {
        pl: "pieczeń wieprzowa",
        de: "das Schweinebraten",
      },
      {
        pl: "pstrag",
        de: "der Forelle",
      },
      {
        pl: "sardynki",
        de: "die Sardinen",
      },
      {
        pl: "łosoś",
        de: "der Lachs",
      },
      {
        pl: "ziemniaki",
        de: "die Kartoffeln",
      },
    ],
  },
];

const ZDANIA32 = [
  {
    name: "[5 klasa] Angielski - past simple - cz II",
    lang: 'en',
    zdania: [
      {
        pl: "opuszczać",
        de: "to leave, left, left",
      },
      {
        pl: "pożyczać komuś",
        de: "to lend, lent, lent",
      },
      {
        pl: "pozwalać",
        de: "to let, let, let",
      },
      {
        pl: "oświetlać",
        de: "to light, lit, lit",
      },
      {
        pl: "tracić",
        de: "to lose, lost, lost",
      },
      {
        pl: "robić",
        de: "to make, made, made",
      },
      {
        pl: "oznaczać",
        de: "to mean, meant, meant",
      },
      {
        pl: "spotykać",
        de: "to meet, met, met",
      },
      {
        pl: "płacić",
        de: "to pay, paid, paid",
      },
      {
        pl: "kłaść",
        de: "to put, put, put",
      },
      {
        pl: "czytać",
        de: "to read, read, read",
      },
      {
        pl: "jeździć",
        de: "to ride, rode, ridden",
      },
      {
        pl: "dzwonić",
        de: "to ring, rang, rung",
      },
      {
        pl: "wzrastać",
        de: "to rise, rose, risen",
      },
      {
        pl: "biec",
        de: "to run, ran, run",
      },
      {
        pl: "mówić",
        de: "to say, said, said",
      },
      {
        pl: "widzieć",
        de: "to see, saw, seen",
      },
      {
        pl: "sprzedawać",
        de: "to sell, sold, sold",
      },
      {
        pl: "wysyłać",
        de: "to send, sent, sent",
      },
      {
        pl: "ustawiać",
        de: "to set, set, set",
      },
      {
        pl: "szyć",
        de: "to sew, sewed, sewn",
      },
      {
        pl: "trząść",
        de: "to shake, shook, shaken",
      },
      {
        pl: "świecić",
        de: "to shine, shone, shone",
      },
      {
        pl: "strzelać",
        de: "to shoot, shot, shot",
      },
      {
        pl: "pokazywać",
        de: "to show, showed, shown",
      },
      {
        pl: "zamykać",
        de: "to shut, shut, shut",
      },
      {
        pl: "śpiewać",
        de: "to sing, sang, sung",
      },
      {
        pl: "spac",
        de: "to sleep, slept, slept",
      },
      {
        pl: "pachnieć",
        de: "to smell, smelt, smelt",
      },
      {
        pl: "rozmawiać",
        de: "to speak, spoke, spoken",
      },
      {
        pl: "wymawiać",
        de: "to spell, spelt, spelt",
      },
      {
        pl: "stać",
        de: "to stand, stood, stood",
      },
      {
        pl: "kraść",
        de: "to steal, stole, stolen",
      },
      {
        pl: "przyklejać",
        de: "to stick, stuck, stuck",
      },
      {
        pl: "uządlić",
        de: "to sting, stung, stung",
      },
      {
        pl: "przysięgać",
        de: "to swear, swore, sworn",
      },
      {
        pl: "wycierać",
        de: "to sweep, swept, swept",
      },
      {
        pl: "pływać",
        de: "to swim, swam, swum",
      },
      {
        pl: "brać",
        de: "to take, took, taken",
      },
      {
        pl: "uczyć",
        de: "to teach, taught, taught",
      },
      {
        pl: "drzeć",
        de: "to tear, tore, torn",
      },
      {
        pl: "mówić",
        de: "to tell, told, told",
      },
      {
        pl: "mysleć",
        de: "to think, thought, thought",
      },
      {
        pl: "rzucić",
        de: "to throw, threw, thrown",
      },
      {
        pl: "rozumieć",
        de: "to understand, understood, understood",
      },
      {
        pl: "wstać",
        de: "to wake, woke, woken",
      },
      {
        pl: "nosić",
        de: "to wear, wore, worn",
      },
      {
        pl: "wygrywać",
        de: "to win, won, won",
      },
      {
        pl: "napisać",
        de: "to write, wrote, written",
      },
    ],
  },
];

const ZDANIA33 = [
  {
    name: "[5 klasa] Niemiecki - ",
    lang: 'de',
    zdania: [
      {
        pl: "On chce zrobić kurs wspinaczkowy, ponieważ nie wie, jak się wspinać",
        de: "Er möchte einen Kletterkurs machen, weil er nicht weiß, wie man klettert",
      },
      {
        pl: "W lecie wyjeżdżam w góry i nad morze",
        de: "Im Sommer fahre ich in die Berge und ans Meer",
      },
      {
        pl: "Ja potrzebuję jego skuter",
        de: "Ich brauche sein Scooter",
      },
      {
        de: "Geht dein Sohn morgen ins Schwimmbad oder bleibt er zu Hause?",
        pl: "Czy Twój syn jutro idzie ns basen czy zostaje w domu?",
      },
      {
        de: "Hast du am 3 Juni Geburtstag?",
        pl: "Czy masz urodziny 3 czerwca?",
      },
      {
        de: "Wem gehört dieses Fahrrad?",
        pl: "Do kogo należy ten rower?",
      },
      {
        de: "Im Sommer ist es heiß und sonnig",
        pl: "W lato jest gorąco i słonecznie",
      },
      {
        de: "Im März möchte ich nach Frankreich an einen See fahren",
        pl: "W marcu chcę pojechać do Francji na jezioro",
      },
      {
        de: "Im März gibt es oft Gewitter und Nebel",
        pl: "W marcu jest często burza i mgła",
      },
      {
        de: "Er möchte euch zu seiner Geburtstagsfeier einladen",
        pl: "On chce zaprosić was na swoje urodziny",
      },
      {
        de: "Wann gehst du zum Tennisplatz und zu Brigitta?",
        pl: "Kiedy idziesz na kort tenisowy i do Brigitt?",
      },
      {
        de: "Tina kommt um 14:15 Uhr nach Hause. Der Unterricht beginnt um 7:55 Uhr",
        pl: "Tina wraca do domu o 14:15. Zajęcia zaczynają się o 7:55",
      },
      {
        de: "unsere Sportschuhe",
        pl: "nasze buty sportowe",
      },
      {
        de: "deine Großmutter",
        pl: "twoja babcia",
      },
      {
        de: "ihr Fahrrad",
        pl: "wasz rower",
      },
      {
        de: "eure Schwester",
        pl: "wasza siostra",
      },
      {
        de: "sein Vater",
        pl: "jego ojciec",
      },
      {
        de: "ihre Trainingshose",
        pl: "ich spodnie dresowe (treningowe)",
      },
      {
        de: "dein Großvater",
        pl: "twój dziadek",
      },
      {
        de: "meine Badehose",
        pl: "moje kąpielówki",
      },
      {
        de: "unsere Schule",
        pl: "nasza szkoła",
      },
      {
        de: "ihr Fahrrad",
        pl: "jej rower",
      },
      {
        pl: "Poukładaj: Montag, besuchen, Tina, am, ein Deutschkurs",
        de: "Am Montag besucht Tina einen Deutschkurs",
      },
      {
        pl: "Poukładaj: das Geschenk, sein, für, du",
        de: "Das Geschenk ist für dich",
      },
      {
        pl: "Poukładaj: Badeanzug, suchen, Eva, ihr ",
        de: "Eva sucht ihren Badeanzug",
      },
      {
        pl: "Poukładaj: einladen, du, vieie Freunde",
        de: "Du lädst viele Freunde ein",
      },
      {
        pl: "Poukładaj: die Schweiz, wollen, nicht, um, ich, 7.00, fahren",
        de: "Ich möchte um 7 Uhr nicht in die Schweiz fahren",
      },
      {
        pl: "Poukładaj: Madrid, fahren, wann, nach, du ?",
        de: "Wann fährst du nach Madrid?",
      },
      {
        pl: "Poukładaj: das Gebirge, fahren, er, in, morgen",
        de: "Er fährt morgen in das Gebirge",
      },
      {
        pl: "Poukładaj: es, in, blitzen, Wroclaw, heute?",
        de: "Blitzt es in Wroclaw heute?",
      },
      {
        pl: "22 maja",
        de: "zwanzig zweiter Mai",
      },
      {
        pl: "1968",
        de: "neunzehnhundertsechzig",
      },
      {
        pl: "1999",
        de: "neunzehnhundertneunundneunzig",
      },
      {
        pl: "2018",
        de: "zweitausendachtzehn",
      },
      {
        pl: "2020",
        de: "zweitausendzwanzig",
      },
    ],
  },
];

const ZDANIA34 = [
  {
    name: "[5 klasa] Niemiecki - Mod 5 Kap 3 - Zdania",
    lang: 'de',
    zdania: [
      {
        pl: "Tina wróciła ze szkoły",
        de: "Tina ist von der Schule zurückgekommen",
      },
      {
        pl: "Ona wyiągnęła rower z piwnicy",
        de: "Sie hat das Fahrrad aus dem Keller geholt",
      },
      {
        pl: "Ona wsiadła na rower",
        de: "Sie ist auf das Fahrrad gestiegen",
      },
      {
        pl: "Potem ona wyruszyła na rowerze",
        de: "Dann ist sie mit dem Fahrrad losgefahren",
      },
      {
        pl: "Ona nie zauważyła pieszego",
        de: "Sie hat einen Fußgänger nicht gesehen",
      },
      {
        pl: "Ona zderzyła się z pieszym",
        de: "Sie ist mit dem Fußgänger zusammengestoßen",
      },
      {
        pl: "Ona spadła",
        de: "Sie ist gestürzt",
      },
      {
        pl: "Zraniła się w prawe ramię",
        de: "Sie hat sich am rechten Arm wehgetan",
      },
      {
        pl: "Ale pieszemu nic się nie stało",
        de: "Dem Fußgänger ist aber nichts passiert",
      },
      {
        pl: "Co w poniedziałek robiłaś?",
        de: "Was hast du am Montag gemacht?",
      },
      {
        pl: "Czy jedliście w domu śniadanie?",
        de: "Habt ihr zu Hause gefrühstückt?",
      },
      {
        pl: "Poszliśmy w środę do kina",
        de: "Wir sind am Mittwoch ins Kino gegangen",
      },
      {
        pl: "Czy Pani oglądała wieczorem telewizję?",
        de: "Haben Sie am Abend ferngesehen?",
      },
      {
        pl: "Co się stało?",
        de: "Was ist passiert?",
      },
      {
        pl: "Kto został wczoraj w domu?",
        de: "Wer ist gestern zu Hause geblieben?",
      },
    ],
  },
];
export { ZDANIA30, ZDANIA31, ZDANIA32, ZDANIA33, ZDANIA34 };
